module.exports = __webpack_public_path__ + "img/a3a030d.jpg";